export const showError = (field, message) => {
  let errorMessage = null;
  if (field && message) {
    errorMessage = <div className="text-red-500">{message}</div>;
  }
  return errorMessage;
};